module.exports = __webpack_public_path__ + "img/SelectMemberPackage.5c1cd538.svg";